import type { Annotation } from '@/modules/Editor/models/annotation/Annotation'
import type { View } from '@/modules/Editor/views/view'

/**
 * Returns the selected annotation.
 * When the selected annotation has a different class from the one selected for the tool, then
 * returns undefined, as editing with a different class is not possible.
 */
export const getEditingAnnotation = (view: View): Annotation | undefined => {
  const { annotationManager } = view
  const preselectedAnnotationClass = annotationManager.preselectedAnnotationClass

  if (!preselectedAnnotationClass) {
    throw new Error('Preselected class not found, this should be selected on tool activation')
  }

  if (
    preselectedAnnotationClass.id &&
    preselectedAnnotationClass.id === annotationManager.selectedAnnotation?.classId
  ) {
    return annotationManager.selectedAnnotation
  }
}
